import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export function useCityDetailsViewModel() {
  const [city, setCity] = useState(null);
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const [communities, setCommunities] = useState([]);

  const getCity = (id) => {
    stateManager.run(async () => {
      const response = await homeService.cities.getById({ id });

      if (response.status === HTTP_STATUSES.OK) {
        setCity(response.data);
      }
    });
  };

  const getCommunities = ({ top, skip } = {}) => {
    return stateManager.run(async () =>
      homeService.communities.getAll({
        sort: "builder/name",
        filters: { city: city?.cityName },
        top,
        skip,
      })
    );
  };

  return {
    city,
    communities,
    isLoading,
    setCommunities,
    getCity,
    getCommunities,
  };
}
